// extracted by mini-css-extract-plugin
export default {"container":"emptyListRequest_container__luJXC","containerImg":"emptyListRequest_containerImg__TTFEJ"};